import { createUseStyles } from 'react-jss';

export const addEditGpcRateStyles = createUseStyles({
  container: {

  },
});
